import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";import React from 'react';
import clsx from 'clsx';
import Button from "../../Button";

import Download from "../../../icons/Download";
import uniqid from 'uniqid';
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import ProductRates from "../common/ProductRates";
import TitleWithSelectedIcon from "../common/TitleWithSelectedIcon";
import { createStyles } from "./styles";



var RenewalCard = function RenewalCard(props) {var _context;
  var
    imPortfolioId =






    props.imPortfolioId,portfolioName = props.carrierPortfolioName,isSelected = props.isSelected,products = props.products,onDownload = props.onDownload,_props$carrier = props.carrier,carrierName = _props$carrier.name,logo = _props$carrier.logo,_props$breakpoint = props.breakpoint,breakpoint = _props$breakpoint === void 0 ? 0 : _props$breakpoint;

  var isMultiProductPortfolio = products.length > 1;
  var showMobileLayoutVersion = useWindowDimensions().width <= breakpoint;

  var classes = createStyles({ isMultiProductPortfolio: isMultiProductPortfolio, showMobileLayoutVersion: showMobileLayoutVersion });

  var id = imPortfolioId || uniqid();
  var DownloadButton = /*#__PURE__*/
  React.createElement(Button, {
    id: "".concat(id, "-download"),
    type: "text",
    color: "primary",
    leftIconProp: /*#__PURE__*/React.createElement(Download, null),
    className: classes.actionButton,
    onClick: onDownload }, "Download exhibits");





  var ProductCardHeader = function ProductCardHeader(name, view) {
    var isPortfolioView = view === 'PORTFOLIO';
    return /*#__PURE__*/(
      React.createElement("header", {
        className: clsx(
        showMobileLayoutVersion ? classes.mobileHeader : classes.header,
        isPortfolioView && classes.shortHeader,
        showMobileLayoutVersion) }, /*#__PURE__*/


      React.createElement(TitleWithSelectedIcon, {
        title: name,
        showIcon: isPortfolioView,
        isCartItemSelected: isSelected }),

      isMultiProductPortfolio && isPortfolioView && DownloadButton));


  };

  return /*#__PURE__*/(
    React.createElement("div", {
      className: clsx(
      classes.cartItemContentWrapper,
      isSelected && classes.cartItemContentWrapperChecked),

      key: "planCard_".concat(id) }, /*#__PURE__*/

    React.createElement("div", { className: clsx(classes.portfolioHeader) }, /*#__PURE__*/
    React.createElement("div", { className: classes.sponsorLogo }, /*#__PURE__*/
    React.createElement("img", { width: "auto", height: "24rem", src: logo, alt: "".concat(carrierName, " logo") })), /*#__PURE__*/

    React.createElement("p", { className: classes.marketingTag }, "Renewal")),

    isMultiProductPortfolio && ProductCardHeader(portfolioName, 'PORTFOLIO'),

    _mapInstanceProperty(_context = _sortInstanceProperty(products).call(products,
    function (a, b) {return a.imProductId > b.imProductId ? 1 : -1;})).call(_context,
    function (_ref) {var carrierProductName = _ref.carrierProductName,renewalCarrierProductName = _ref.renewalCarrierProductName,rates = _ref.rates;
      // Provided id in the product may be not unique
      var uniqueId = uniqid();
      var convertedRates = _mapInstanceProperty(rates).call(rates, function (_ref2) {var rateStructure = _ref2.rateStructure,renewalRate = _ref2.renewalRate;return {
          displayKey: rateStructure,
          key: rateStructure,
          value: Number(renewalRate) || 0
        };});

      return /*#__PURE__*/(
        React.createElement("div", { key: "productCard_".concat(uniqueId), className: classes.innerProduct },
        ProductCardHeader(
        renewalCarrierProductName || carrierProductName,
        isMultiProductPortfolio ? 'PRODUCT' : 'PORTFOLIO'), /*#__PURE__*/


        React.createElement("div", { className: classes.portfolioMainData }, /*#__PURE__*/
        React.createElement(ProductRates, { id: uniqueId, rates: convertedRates, styles: classes.ratesList }), /*#__PURE__*/
        React.createElement("div", { className: classes.actionButtonWrapper },
        !isMultiProductPortfolio && DownloadButton))));




    })));


};

export default RenewalCard;
//# sourceMappingURL=index.js.map